<template>
  <div class="alert alert-dismissible" :class="'alert-' + errorClass" role="alert">
    <button aria-label="Close" class="close" data-dismiss="alert" type="button" @click="$emit('hide', id)" v-if="id >= 0">
      <svg class="lexicon-icon lexicon-icon-times icon-monospaced" focusable="false" role="image" viewBox="0 0 512 512">
        <path class="lexicon-icon-outline" d="M295.781 256l205.205-205.205c10.998-10.998 10.998-28.814 0-39.781-10.998-10.998-28.815-10.998-39.781 0l-205.205 205.205-205.205-205.238c-10.966-10.998-28.814-10.998-39.781 0-10.998 10.998-10.998 28.814 0 39.781l205.205 205.238-205.205 205.205c-10.998 10.998-10.998 28.815 0 39.781 5.467 5.531 12.671 8.265 19.874 8.265s14.407-2.734 19.907-8.233l205.205-205.238 205.205 205.205c5.5 5.5 12.703 8.233 19.906 8.233s14.407-2.734 19.906-8.233c10.998-10.998 10.998-28.815 0-39.781l-205.238-205.205z"></path>
      </svg>
      <span class="sr-only">Close</span>
    </button>
    <div class="message-container">
      <strong class="lead" v-if="showTitle">{{ $t('hs.att-dashboard.' + errorClass) }}</strong>
      <slot>{{ $t(errorMessageKey) }}</slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'alertMessage',

    props: {
      id: {
        type: Number
      },
      errorMessageKey: {
        type: String,
        required: true
      },
      showTitle: {
        type: Boolean,
        default: true
      },
      scrollOnCreated: {
        type: Boolean,
        default: false
      },
      errorParams: {
        type: String,
        default: ''
      },
      errorClass: {
        type: String,
        required: true,
        validator: function (value) {
          return [
            'default',
            'success',
            'info',
            'warning',
            'danger'
          ].indexOf(value) >= 0
        }
      }
    },

    data () {
      return {
        componentName: 'alertMessage'
      }
    },

    mounted () {
      if (this.scrollOnCreated) {
        this.$el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
</script>

<style scoped lang="scss">
  .alert-danger {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
  }

  .alert-warning {
    color: #8a6d3b;
    background-color: #fcf8e3;
    border-color: #faebcc;
  }

  .alert .close {
    top: -4px;
  }

  .lead {
    margin-bottom: prem(5);
  }

  .alert {
    margin: 0;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  .alert-dismissable, .alert-dismissible {
    padding-right: 35px;
  }

  .message-container {
    display: flex;
    flex-direction: column;
  }
</style>
<style lang="scss">
  .alert + .alert {
    margin-top: prem(20);
  }
</style>
